import { observer } from "mobx-react";
import React, { memo, useState, useEffect } from "react";
import { Grid, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { useStore } from "app/stores";
import TreamentImagePatient from "./TreamentImagePatient";
import ImageAdviceTabIndex from "./ImageAdviceTabIndex";
import ImageGeneralTabIndex from "./ImageGeneralTab/ImageGeneralTabIndex";

const TREATMENT_IMAGE_TABS = [
  {
    tabName: "Ảnh trước và sau điều trị",
    content: (
      <>
        <TreamentImagePatient />
      </>
    ),
    value: 0,
  },
  {
    tabName: "Ảnh tư vấn",
    content: (
      <>
        <ImageAdviceTabIndex />
      </>
    ),
    value: 1,
  },
  {
    tabName: "Ảnh chung",
    content: (
      <>
        <ImageGeneralTabIndex />
      </>
    ),
    value: 2,
  },
];
const ImageTreatmentTabIndex = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const tabTimeoutRef = React.useRef(null);

  const { reset } = useStore().treatmentManagementStore.treamentInfoPatientStore;

  const handleTabChange = (_, newTabIndex) => {
    if (tabTimeoutRef.current) {
      clearTimeout(tabTimeoutRef.current);
    }
    tabTimeoutRef.current = setTimeout(() => {
      setCurrentTab(newTabIndex);
    }, 150);
  };

  useEffect(() => {
    return () => {
      if (tabTimeoutRef.current) {
        clearTimeout(tabTimeoutRef.current);
      }
      reset(); // Revoke all blobs on unmount (Memory Control)
    };
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TabContext value={currentTab}>
          <TabList
            className="tabs-container-white tab-custom-fee"
            // variant="scrollable"
            // scrollButtons="on"
            onChange={handleTabChange}
            value={currentTab}
          >
            {TREATMENT_IMAGE_TABS.map((tab, index) => (
              <Tab
                key={index}
                className={`item-tabs  ${
                  index === currentTab ? "item-tabs-active" : ""
                }`}
                label={tab.tabName}
                value={index}
              />
            ))}
          </TabList>
          {TREATMENT_IMAGE_TABS.map((tab, index) => (
            <TabPanel
              component="section"
              className="p-0"
              key={tab.value}
              value={index}
            >
              {currentTab === index && tab.content}
            </TabPanel>
          ))}
        </TabContext>
      </Grid>
    </Grid>
  );
};

export default memo(observer(ImageTreatmentTabIndex));
